<template>
  <div :class="['coupons-item',{'coupons-invite':itemData.type==='invite'}]">
    <p class="item-title">{{itemData.title}}</p>  
    <p 
      v-if="itemData.type==='invite'" 
      class="item-des">
      {{sprintf(gettext('可获得%s优惠券'), itemData.des)}}
    </p>
    <p v-else class="item-des">{{gettext('仅售')}} {{itemData.des}}</p>
    <p class="item-link" @click="handleLink(itemData.type)" ontouchstart="">
      {{gettext('查看更多')}}<i class="c-common_icon_arrow"></i>
    </p>
    <slot name="btn"></slot>
    <p v-if="itemData.type==='invite'" class="item-fixed"></p>
  </div>
</template>

<script>
import { couponViewCk, cgcCardViewCk } from '../../track'
import { sprintf, getLocale } from '@didi/gettext'

export default {
  name: 'CouponsItem',
  props: {
    text: {
      type: String,
      defalut: ''
    },
    itemData: {
      type: Object,
      default: {
        type: 'pay'
      }
    }
  },
  data () {
    return {
      sprintf: sprintf
    }
  },
  methods: {
    handleLink (type) {
      const shopId = this.itemData.shopId || 0
      const {protocol, host} = location
      if (type === 'pay') {
        this.SodaBridge('openPage', {
          target: 'blank',
          url: `${protocol}//${host}/${getLocale()}/c/coupon/detail?isBuy=1&shopId=${shopId}`
        })
        couponViewCk()
      } else {
        this.SodaBridge('openPage', {
          target: 'blank',
          url: `${protocol}//${host}/${getLocale()}/c/landingPage`
        })
        cgcCardViewCk()
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/var.scss";
.coupons-item{
  box-sizing: border-box;
  background: #fff;
  text-align: center;
  border-radius: 12px;
  @include coupon-buy-bg();
  margin-bottom:20px;
  padding: 80px 82px 48px;
  background-repeat:no-repeat;
  position: relative;
  .item-title{
    font-family: 'Aspira Medium';
    font-size: 48px;
    line-height: 56px;
  }
  .item-des{
    font-family: 'Aspira Light';
    font-size: 40px;
    margin-top: 18px;
  }
  .item-link{
    display: block;
    font-family: 'Aspira Light';
    font-size: 32px;
    height: 32px;
    line-height: 32px;
    color: #000000;
    margin: 28px 0 40px 0;
    i{
      display: inline-block;
      font-size: 18px;
      margin-left: 5px;
      position: relative;
      bottom: 2px;
    }
  }
  .item-link:active{
    opacity: .5;
  }
  .item-fixed{
    width:60px;
    height: 60px;
    position: absolute;
    bottom:0;
    @include coupon-invite-bottom-bg()
  }
}
.coupons-invite{
  @include coupon-invite-bg()
}

</style>